module.exports = __webpack_public_path__ + "img/DotsThree.3186b841.svg";